<template>
  <div :class="['settingsBox', isDark ? 'settingsBoxDark' : '']">
    <div class="title">
      <h2>用户设置</h2>
    </div>
    <div class="settingsContent scrollStyle">
      <!-- 个人信息 -->
      <div class="set">
        <div class="setTit" @click="showInfo">
        <!-- <div class="setTit" @click="isShowInfo = !isShowInfo"> -->
          <div class="setTitle">
            <h4>个人信息</h4>
            <span>设置个人信息</span>
          </div>
          <div :class="['iconBox', !isShowInfo ? 'rotateIcon' : '']">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="setForm scrollStyle" :style="{ maxHeight: isShowInfo ? '500px' : '0px' }">
          <div class="interval">
            <el-form ref="infoForm" :rules="infoRules" :model="infoForm" label-width="0px">
              <el-form-item prop="userName">
                <el-input 
                  v-model="infoForm.userName" 
                  maxlength="10" 
                  placeholder="请输入昵称"
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="account">
                <el-input 
                  v-model="infoForm.account" 
                  maxlength="10" 
                  placeholder="请输入用户名"
                  disabled
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input 
                  v-model="infoForm.phone" 
                  placeholder="请输入手机号"
                  disabled
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                >
                </el-input>
              </el-form-item>
              <!-- <el-form-item prop="birthday" :key="FormKey">
                <el-date-picker
                  v-model="infoForm.birthday"
                  type="month"
                  placeholder="出生年月"
                  :class="['dateInput', isDark ? 'darkInput' : '']"
                  :popper-class="datePopper"
                  :picker-options="pickerOptions"
                  :disabled="this.user.birthday"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="gender">
                <el-select
                  v-model="infoForm.gender"
                  placeholder="请选择性别"
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                  :popper-class="datePopper"
                  :disabled="this.user.gender"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="city">
                <el-cascader
                  placeholder="请选择城市"
                  :options="cityList"
                  filterable
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                  :popper-class="datePopper"
                  :disabled="this.user.city"
                >
                </el-cascader>
              </el-form-item> -->
              <el-form-item>
                <el-button :loading="infoLoading" type="primary" @click="submitInfo" class="submitBtn">
                  <!-- 保存 -->
                  {{ infoLoading ? '保存中' : '保存' }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 账号安全 -->
      <div class="set">
        <div class="setTit" @click="isShowSafe = !isShowSafe">
          <div class="setTitle">
            <h4>账号安全</h4>
            <span>修改密码</span>
          </div>
          <div :class="['iconBox', !isShowSafe ? 'rotateIcon' : '']">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="setForm scrollStyle" :style="{ maxHeight: isShowSafe ? '260px' : '0px' }">
          <div class="interval">
            <el-form ref="changePwdForm" :rules="changePwdRules" :model="pwdForm" label-width="0px">
              <el-form-item  prop="oldPassword">
                <el-input 
                  type="password" 
                  v-model="pwdForm.oldPassword" 
                  placeholder="当前密码"
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="newPassword">
                <el-input 
                  type="password" 
                  v-model="pwdForm.newPassword" 
                  placeholder="新密码"
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                >
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button 
                  type="primary" 
                  @click="updatePwd" 
                  class="submitBtn"
                  :loading="pwdLoading"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 设置回答 -->
      <div class="set">
        <div class="setTit" @click="showStyle">
          <div class="setTitle">
            <h4>设置回答</h4>
            <span>设置回答是偏向于“严谨准确”还是更“多样化”</span>
          </div>
          <div :class="['iconBox', !isShowStyle ? 'rotateIcon' : '']">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="setForm scrollStyle" :style="{ height: isShowStyle ? '100px' : '0px' }">
          <div class="styleInterval">
            <el-slider 
              v-model="temperature" 
              :step="0.1" 
              show-stops 
              :max="1"
              :marks="{ 0.2: '保守准确', 0.5: '平衡', 0.8: '多样化' }"
              @change="changeTemperature"
              :show-tooltip="showTooltip"
            >
            </el-slider>
          </div>
        </div>
      </div>
      <!-- 分享链接 -->
      <div class="set" v-if="user.promoCode">
        <div class="setTit" @click="getShareLink">
          <div class="setTitle">
            <h4>分享链接</h4>
            <span>邀请成员一起体验捷捷AI带来的惊喜吧~</span>
          </div>
          <div :class="['iconBox', !isShowShare ? 'rotateIcon' : '']">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="setForm scrollStyle" :style="{ maxHeight: isShowShare ? '200px' : '0px' }">
          <div class="interval">
            <div class="linkInput">
              <el-input 
                v-model="inviteUrl" 
                placeholder="http://gpt.yilvwuyou.com/login?code=106088"
                :class="['searchInput', isDark ? 'darkInput' : '']"
                readonly
              >
              </el-input>
            </div>
            <el-button type="primary" @click="copyLink" class="submitBtn">复制链接</el-button>
          </div>
        </div>
      </div>
      <!-- 用户反馈 -->
      <div class="set">
        <div class="setTit" @click="showFeedback">
          <div class="setTitle">
            <h4>用户反馈</h4>
            <!-- <span>。。。</span> -->
          </div>
          <div :class="['iconBox', !isShowFeedback ? 'rotateIcon' : '']">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="setForm scrollStyle" :style="{ maxHeight: isShowFeedback ? '200px' : '0px' }">
          <div class="interval">
            <el-form :model="feedbackForm" ref="feedbackForm" :rules="infoRules">
              <el-form-item label="" prop="feedback">
                <el-input 
                  type="textarea"
                  v-model="feedbackForm.feedback" 
                  :rows="3"
                  placeholder="请输入意见建议或在使用过程中遇到的问题，或其他你想要告诉我们的东西"
                  :class="['searchInput', isDark ? 'darkInput' : '']"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-button
              type="primary" 
              @click="submitFeedback" 
              class="submitBtn"
              :loading="feedbackLoading"
            >
              {{ feedbackLoading ? '提交中' : '提交' }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 反馈记录 -->
      <!-- <div class="set">
        <div class="setTit" @click="showFeedbackRecord">
          <div class="setTitle">
            <h4>反馈记录</h4>
            <span>。。。</span>
          </div>
          <div :class="['iconBox', isShowFeedbackRecord ? 'rotateIcon' : '']">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="setForm scrollStyle" :style="{ maxHeight: isShowFeedbackRecord ? '350px' : '0px' }">
          <div class="interval">
            <div v-for="(item, index) in msgList" :key="index" @click="showFeedbackDetail">
              <Msg :showAvatar="false" :news="item"></Msg>
            </div>
          </div>
        </div>
      </div> -->
      <div class="mt-4">
        <el-button type="primary" plain @click="handleLogout">退出登录</el-button>
      </div>
    </div>
    <!-- 反馈记录详情 -->
    <el-dialog title="反馈详情" :visible.sync="dialogTableVisible">
      反馈详情
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/utils/utils";
// import util from "@/utils/utils";
import Msg from '../+components/Msg';
import {mapState, mapMutations, mapActions} from 'vuex';
import wx from 'weixin-js-sdk';

export default {
  name: 'Settings',
  components: { Msg },
  props: {},
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      const reg = /^1[3-9]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的手机号'));
      }
    };
    return {
      updateUserByClient: api.updateUserByClient,
      getUserInfo: api.getUserInfo,
      changePwd: api.changePwd,
      feedback_submit: api.feedback_submit,
      infoForm: {
        userName: '',
        account: '',
        phone: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      options: [
        {
          label: '女',
          value: 0,
        },
        {
          label: '男',
          value: 1,
        },
      ],
      cityList: [],
      infoRules: {
        userName: [
          { required: true, message: '昵称不能为空', trigger: 'blur' },
        ],
        account: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
        // phone: [
        //   { validator: checkPhone, trigger: 'blur' },
        // ],
        feedback: [
          { required: true, message: '反馈内容不能为空', trigger: 'blur' },
        ]
      },
      pwdForm: {
        oldPassword: '',
        newPassword: ''
      },
      changePwdRules: {
        oldPassword: [
          { required: true, message: "请输入当前密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在6到20个字符之间",
            trigger: "blur",
          },
        ],
      },
      feedbackForm: {
        feedback: ''
      },
      isShowInfo: false,
      isShowSafe: false,
      isShowStyle: false,
      isShowShare: false,
      isShowFeedback: false,
      isShowFeedbackRecord: false,
      infoLoading: false,
      pwdLoading: false,
      feedbackLoading: false,
      temperature: 0,
      showTooltip: true, // 是否展示滑块的文字提示
      timer: null, // 定时器
      // dateStyle: '',
      inviteUrl: '', // 邀请链接
      feedbackInput: '', // 用户反馈
      dialogTableVisible: false, // 展示反馈详情
      FormKey: 0,
      sessionKey: "sessionKey",
      msgList: [
        // {
        //   textTitle: '我的反馈1',
        //   textContent: '反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息',
        // },
        // {
        //   textTitle: '我的反馈1',
        //   textContent: '反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息',
        // },
        // {
        //   textTitle: '我的反馈1',
        //   textContent: '反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息',
        // },
        // {
        //   textTitle: '我的反馈1',
        //   textContent: '反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息反馈信息',
        // },
      ],
    }
  },
  computed: {
    ...mapState('userAbout', ['user', 'count']),
    ...mapState('comAbout', ['isDark']),
    // 日期选择下拉样式
    datePopper() {
      return this.isDark ? 'datePopper' : '';
    },
  },
  watch: {
    isDark: {
      handler(val) {
        this.FormKey++
      },
      immediate: true,
    },
  },
  created() { },
  mounted() {
    this.shareUrl();
  },
  methods: {
    ...mapMutations('userAbout', ['setCount']),
    ...mapActions('userAbout', ['updateUserInfo']),
    //分享链接
		async shareUrl(){
			const protocol = window.location.protocol
			const hostname = window.location.host
			// const row = this.$route.query
			if(this.user.promoCode){
				this.inviteUrl = protocol + '//' + hostname + '/login?code=' + this.user.promoCode
				// this.inviteUrl = protocol + '//' + hostname + '/login?code=' + row.promoCode
				// this.qrCodeUrl = await this.$utils.generateQRCode(this.inviteUrl,200)
			}
		},
    // 退出登录
    handleLogout() {
      this.$confirm("退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: this.isDark ? 'darkMessage' : '',
      })
        .then(() => {
          this.logout();
        })
        .catch(() => {
          // 用户点击了取消按钮
        });
    },
    //退出登录处理
    logout() {
      //清除用户数据
      this.session = "";
      localStorage.removeItem(this.sessionKey);
      this.isAuth = false;

      this.closeAllShowingMsg();

      //刷新页面
      //window.location.reload();

      //到登录页
      // this.$router.push("/login");
      // console.log('logout');
      // const ua = navigator.userAgent.toLowerCase();
      // console.log(ua, 'ua', window.__wxjs_environment);
      // 小程序环境-回到小程序首页
      if (window.__wxjs_environment == 'miniprogram') {
        wx.miniProgram.getEnv(res => {
          // console.log('res', res);
          if (res.miniprogram) {
            // 微信小程序内
            wx.miniProgram.switchTab({
              url: "/pages/chatHistory/index"
            })
          }
        })
      } else {
        // 其他环境-到登录页
        this.$router.push("/login");
      }

      // wx.miniProgram.switchTab({
      //   url: '/pages/chatHistory/index'
      // })
      // this.$router.back();

      //清除对话
      //this.taleList = [];

      // this.dialogDrawerUserVisible = false;
      // this.$refs.login.show();
    },
    //关闭所有悬停的弹窗
    closeAllShowingMsg() {
      this.$message.closeAll();
    },
    // 展示反馈详情
    showFeedbackDetail() {
      this.dialogTableVisible = true;
    },
    // 点击反馈记录
    showFeedbackRecord() {
      this.isShowFeedbackRecord = !this.isShowFeedbackRecord;
    },
    // 提交反馈
    submitFeedback() {
      // console.log(this.feedbackInput);
      this.$refs.feedbackForm.validate((val) => {
        console.log(val);
        if (val) {
          this.feedbackLoading = true;
          this.feedback_submit({
            userId: this.user.id,
            content: this.feedbackForm.feedback,
          }).then((res) => {
            if (res.success) {
              this.isShowFeedback = false;
              this.feedbackLoading = false;
              this.feedbackForm.feedback = '';
              this.$message.success('提交成功！');
            } else {
              this.$message.error('提交出错：' + res.message);
            }
          }).catch((err) => {
            this.$message.error("提交出错：" + err.toString());
            this.feedbackLoading = false;
          })
        }
      })
      // if (!this.feedbackInput) {
      //   this.$message.error("反馈内容不能为空");
      //   return;
      // }
    },
    // 点击用户反馈
    showFeedback() {
      this.isShowFeedback = !this.isShowFeedback;
      this.$refs.feedbackForm.clearValidate();
    },
    // 获取分享链接
    getShareLink() {
      this.isShowShare = !this.isShowShare;
      console.log('分享链接');
    },
    // 复制链接
    copyLink() {
      utils.handCopy(this.inviteUrl);
    },
    // 设置回答
    changeTemperature(val) {
      this.timer = setTimeout(() => {
        this.showTooltip = false;
        this.openTooltip();
      }, 500);
      console.log(val);
      const param = {
        userName: this.user.userName,
        account: this.user.account,
        avatarFile: this.user.avatarFile,
        temperature: val,
      };
      this.updateUserByClient(param).then((res) => {
        if (res.success) {
          // this.getLatelyUserInfo();
          this.updateUserInfo();
          this.$message.success('操作成功');
          this.isShowStyle = !this.isShowStyle;
        } else {
          this.$message.error(res.message);
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    // 打开tooltip
    openTooltip() {
      this.timer = setTimeout(() => {
        this.showTooltip = true;
        clearTimeout(this.timer)
      }, 500)
    },
    // 点开设置回答
    showStyle() {
      this.isShowStyle = !this.isShowStyle;
      this.temperature = this.user.temperature;
    },
    // 修改密码
    updatePwd() {
      const _this = this;
      this.$refs.changePwdForm.validate((valid) => {
        if (valid) {
          this.pwdLoading = true;
          this.changePwd({
            oldPassword: this.pwdForm.oldPassword,
            newPassword: this.pwdForm.newPassword,
          }).then((res) => {
            _this.pwdLoading = false
            if (res.success) {
                this.$message({
                  message: `修改成功`,
                  type: "success",
                });
                // this.dialogChangePwdVisible = false;
                this.isShowSafe = !this.isShowSafe;
                this.pwdForm = {};
              } else {
                var msgs = utils.getMsgs(res);
                var errmsg = msgs.join(",");
                this.$message.error("修改失败：" + errmsg);
              }
          }).catch(() => {
            _this.pwdLoading = false
          })
        }
      })
    },
    // 点击个人信息
    showInfo() {
      this.isShowInfo = !this.isShowInfo;
      if (this.isShowInfo) {
        // 清除表单验证结果
        this.$refs.infoForm.clearValidate();
        this.infoForm = {
          userName: this.user.userName,
          account: this.user.account,
          phone: this.user.phone
        }
      }
    },
    // 更新个人信息
    submitInfo() {
      this.$refs.infoForm.validate((val) => {
        // const _this = this;
        if (val) {
          this.infoLoading = true;
          const param  = {
            userName: this.infoForm.userName,
            account: this.infoForm.account,
            avatarFile: this.user.avatarFile,
          };
          this.updateUserByClient(param).then((res) => {
            this.infoLoading = false;
            if (res.success) {
              // callback && callback(true);
              // this.getLatelyUserInfo();
              this.updateUserInfo();
              this.$message.success('操作成功');
              this.isShowInfo = !this.isShowInfo;
            } else {
              // callback && callback(false);
              this.$message.error(res.message);
            }
          }).catch(() => {
            this.infoLoading = false;
          })
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.settingsBox {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;

  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;

    h2 {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .settingsContent {
    margin: 16px 0;
    overflow-y: auto;
    overflow-x: hidden;

    .set {
      .setTit {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .setTitle {
          h4 {
            font-size: 15px;
            color: #222;
            font-weight: 600;
          }

          span {
            font-size: 12px;
            color: #aaa;
            display: block;
            font-weight: 400;
            margin-top: 7px;
          }
        }

        .iconBox {
          transition: all .3s;

          i {
            color: #aaa;
            font-size: 24px;
          }
        }

        .rotateIcon {
          transform: rotate(180deg);
        }
      }

      .setForm {
        margin-top: 30px;
        transition: height .3s, max-height .3s;
        // overflow: hidden;
        overflow-y: auto;
        overflow-x: hidden;

        // overflow-x: scroll;
        // padding: 2px;
        .interval {
          margin: 4px;

          .submitBtn {
            background-color: #2f80ec;
            min-width: 150px;
            border-radius: 8px;
            line-height: 45px;
            height: 45px;
            padding: 0 20px;
            font-size: 13px;
            color: #fff;
            font-family: Montserrat, sans-serif;
            box-shadow: 0 8px 30px rgba(0, 0, 0, .03);
            border: 0;
          }
          .linkInput {
            margin: 16px 0px;
          }
        }

        .styleInterval {
          margin: 10px;
        }

      }
    }

    /* 针对整个滚动条 */
    &::-webkit-scrollbar {
      width: 3px;
      /* 滚动条的宽度 */
    }

    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
      // background: #f1f7fe; /* 滚动条轨道的背景色 */  
      background: transparent;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      // background: #f1f7fe; /* 滚动条滑块的颜色 */  
      background: transparent;
      border-radius: 5px;
      /* 滑块边缘的圆角 */
    }

    &:hover::-webkit-scrollbar-thumb {
      background: rgb(238, 238, 238);
    }
  }
}
// 暗色主题
.settingsBoxDark {
  .settingsContent {
    .set {
      .setTit {
        .setTitle {
          h4 {
            color: #ddd;
          }
        }
      }
    }
  }
}
</style>

<!-- element样式修改 -->
<style lang="less">
.settingsBox {
  .settingsContent {
    .set {
      .setForm {
        .interval {
          .dateInput {
            width: 100%;
            height: 55px;
            line-height: 55px;
            font-size: 13px;
            // padding: 0 20px;
           
            .el-input__inner {
              height: 55px;
              line-height: 55px;
              border: 0;
              border-radius: 8px;
              background-color: #ebeff4;
            }
            .el-input__inner:focus {
              box-shadow: 0 0 0 3.2px rgba(0, 123, 255, .25);
            }
          }
          .darkInput {
            .el-input__inner, .el-textarea__inner {
              background-color: #293145;
              color: #ddd;
            }
          }
          // .el-input.is-disabled.darkInput .el-input__inner{
          //   background-color: #293145;
          //   color: #ddd;
          // }
        }
      }
    }
  }
}
// 暗黑模式日期选择下拉框
.datePopper {
  background-color: #293145;
  color: #ddd;
  .el-date-picker__header-label {
    color: #ddd;
    &:hover {
      color: #409EFF;
    }
    &:active {
      color: #409EFF;
    }
  }
  .el-month-table td .cell {
    color: #ddd;
    &:hover {
      color: #409EFF;
    }
  }
  .el-month-table td.today .cell {
    color: #409EFF;
  }
  .el-picker-panel__icon-btn {
    color: #ddd;
    &:hover {
      color: #409EFF;
    }
  }
  .el-picker-panel__footer{
    background-color: #293145;
    color: #ddd;
  }
  .el-input__inner {
    background-color: #293145;
    color: #ddd;
  }
  .el-time-panel {
    background-color: #293145;
    color: #ddd;
  }
  .el-time-spinner__item {
    color: #ddd;
  }
  .el-time-spinner__item.active:not(.disabled) {
    color: #fff;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #293145;
    color: #ddd;
  }
  .el-month-table td.disabled .cell {
    background-color: #293145;
    color: #606266;
  }
  
  .el-date-table td.in-range div, 
  .el-date-table td.in-range div:hover, 
  .el-date-table.is-week-mode .el-date-table__row.current div, 
  .el-date-table.is-week-mode .el-date-table__row:hover div {
    background-color: #1a2236;
  }
}
// 暗黑模式消息提示框
.darkMessage {
  background-color: #293145;
  .el-message-box__title {
    color: #fff;
  }
  .el-message-box__content{
    color: #aaa;
  }
}
</style>